import { Link } from 'react-router-dom';
import { aboutPrinciples } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function PrinciplesSection() {
  return (
    <section id="principles" className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="Our Principles"
            title="五条内容原则"
            description="这五条原则决定了我们做什么、不做什么。它们比任何一次选题都更稳定，也不会因为外部压力而调整。"
            align="center"
          />

          <div className="mt-12 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {aboutPrinciples.map((item, index) => (
              <article
                key={item.title}
                className="flex flex-col bg-background-50 border border-foreground-950/10 rounded-lg p-6 md:p-7 hover:border-secondary-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="font-mono text-2xl text-foreground-200">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}

            <article className="flex flex-col justify-between bg-primary-500 text-background-50 rounded-lg p-6 md:p-7">
              <div>
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50/15 text-background-50">
                  <i className="ri-send-plane-line text-xl"></i>
                </span>
                <h3 className="mt-6 font-heading text-lg font-bold">
                  这些原则需要被一起守住
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-background-50/90">
                  如果你在投稿过程中遇到违背以上原则的沟通，请立即中止并告知我们。
                </p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 border border-background-50/40 hover:bg-background-50 hover:text-primary-600 px-5 py-3 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们核实
                <i className="ri-arrow-right-line"></i>
              </Link>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}